// Haptic feedback (v1 effects-manager vibrate). Patterns are v1's.

export function vibrate(pattern: number | readonly number[]): void {
  if ('vibrate' in navigator) {
    try {
      navigator.vibrate(pattern as number | number[]);
    } catch {
      // Some browsers throw on vibrate without user gesture — ignore
    }
  }
}

export const HAPTICS = {
  nearMiss: 30, // v1 game3d.js:794
  comboTier: [20, 40, 20], // v1 :1030
  powerUp: [30, 50, 30], // v1 :1100
  beltChange: [30, 40, 60], // v1 :944
  secondWind: [50, 50, 50], // v1 :1143
} as const;
